import UIDs from "../../../../UIDs";

const uid = UIDs.screens.homework.homeworkunit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    REPORT_RESULT: `${uid}.reportResult`,
    NEXT_UNIT_ASYNC: `${uid}.nextUnitAsync`,
    NEXT_UNIT_SUCCESS: `${uid}.nextUnitSuccess`,
    NEXT_UNIT_FAILURE: `${uid}.nextUnitFailure`,
    GOTO_UNIT_ASYNC: `${uid}.gotoUnitAsync`,
    GOTO_UNIT_SUCCESS: `${uid}.gotoUnitSuccess`,
    GOTO_UNIT_FAILURE: `${uid}.gotoUnitFailure`,
    UPDATE_UNIT_RESULT_ASYNC: `${uid}.updateUnitResultAsync`,
    UPDATE_UNIT_RESULT_SUCCESS: `${uid}.updateUnitResultSuccess`,
    UPDATE_UNIT_RESULT_FAILURE: `${uid}.updateUnitResultFailure`,
    UPDATE_UNIT_DRAFT_ASYNC: `${uid}.updateUnitDraftAsync`,
    UPDATE_UNIT_DRAFT_SUCCESS: `${uid}.updateUnitDraftSuccess`,
    UPDATE_UNIT_DRAFT_FAILURE: `${uid}.updateUnitDraftFailure`,
    COMPLETE_HOMEWORK_ASYNC: `${uid}.completeHomeworkAsync`,
    COMPLETE_HOMEWORK_SUCCESS: `${uid}.completeHomeworkSuccess`,
    COMPLETE_HOMEWORK_FAILURE: `${uid}.completeHomeworkFailure`,
    SHOW_UNIT_NAVIGATION: `${uid}.showUnitNavigation`,
    SHOW_SKIP_NOTICE: `${uid}.showSkipNotice`,
    SHOW_FOOTER: `${uid}.showFooter`,
    SHOW_COMMON_MODAL_REF: `${uid}.showCommonModalRef`,
    UPDATE_SETTINGS: `${uid}.updateSettings`,
    TOGGLE_ANSWER_ICON: `${uid}.toggleAnswerIcon`,
    CLOSE_ALERT: `${uid}.closeAlert`,
    RESTART_ASYNC: `${uid}.restartAsync`,
    RESTART_ASYNC_SUCCESS: `${uid}.restartAsyncSuccess`,
    RESTART_ASYNC_FAILURE: `${uid}.restartAsyncFailure`,
    SET_RECORD_SETTING_FROM_LOCAL: `${uid}.setRecordSettingFromLocal`,
    USER_HOMEWORK_STATUS_CHANGE: `${uid}.homeworkStatusChange`,
    TRY_START_COMPLETE_HOMEWORK: `${uid}.tryStartCompleteHomework`,
    START_HOMEWORK_ASYNC: `${uid}.startHomeworkAsync`,
    START_HOMEWORK_SUCCESS: `${uid}.startHomeworkSuccess`,
    START_HOMEWORK_FAILURE: `${uid}.startHomeworkFailure`,
    REFRESH_HOMEWORK_UNIT_TASK_PROGRESS: `${uid}.refreshHomeworkUnitTaskProgress`,
    REFRESH_HOMEWORK_TASK_PROGRESS: `${uid}.refreshHomeworkTaskProgress`,
};

export { ActionTypes };
